import { IComponentController, ILogService } from 'angular'
import { IIModel } from '../../../../model/candidato-api'
import { Editor } from './editor'

export class EditorBaseCtrl<T extends IIModel> implements IComponentController {
  constructor(
    protected $log: ILogService,
    protected _editor: Editor<T>
  ) {}
}
